import { render, staticRenderFns } from "./CRUD.vue?vue&type=template&id=50bc2a16"
import script from "./CRUD.vue?vue&type=script&lang=js"
export * from "./CRUD.vue?vue&type=script&lang=js"
import style0 from "./CRUD.vue?vue&type=style&index=0&id=50bc2a16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports